module.exports = __webpack_public_path__ + "static/img/暂无图片.51d90634.png";